module.exports = __webpack_public_path__ + "img/143.30091c43.png";